const BASE = "/tag";

const CREATE_TAG = `${BASE}/create-tag`;
const UPDATE_TAG = `${BASE}/update-tag/{TAG_ID}`;
const GET_LIST_TAG = `${BASE}/get-list-tag`;
const DELETE_TAG = `${BASE}/delete-tag/{TAG_ID}`;

export const TAG_ROUTE = {
  CREATE_TAG,
  UPDATE_TAG,
  GET_LIST_TAG,
  DELETE_TAG,
};
